import { getFieldLabel } from "@/util/DataUtil";
export default {
  getHead: () => {
    return [{ name: "사업장명" }, { name: "이름" }, { name: "구분" }, { name: "직종" }, { name: "실시유무" }, { name: "작성자" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).inputA_9; // 사업장명
      case 1:
        return func.getContent(value).inputA_7; // 이름
      case 2:
        return func.getContent(value).inputA_5; // 구분
      case 3:
        return func.getContent(value).inputA_6; // 직종
      case 4:
        return func.getContent(value).inputB_1; // 실시유무
      case 5:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      case 6:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case "사업장명":
      return ["content$body.inputA_9*%[:default_skw]%"];
    case "이름":
      return ["content$body.inputA_7*%[:default_skw]%"];
    case "구분":
      return ["content$body.inputA_5*%[:default_skw]%"];
    case "직종":
      return ["content$body.inputA_6*%[:default_skw]%"];
    case "실시유무":
      return ["content$body.inputB_1*%[:default_skw]%"];
    case "작성자":
      return ["content$body.stdInfo.writer_name*%[:default_skw]%"];
    }
    return [];
  },
};
